import {Component, Input} from '@angular/core';
import {DcpEntryGroup} from '@dcp/configurator';
import {Observable} from 'rxjs';
import {ContractPriceService} from '../services/contract-price.service';

@Component({
  selector: 'dcp-additional-required-solutions-button',
  templateUrl: './additional-required-solutions-button.component.html',
  styleUrls: ['./additional-required-solutions-button.component.scss']
})
export class AdditionalRequiredSolutionsButtonComponent {

  @Input() derivativeCount: number;
  derivativePrice$: Observable<string>;
  isModalOpened: boolean = false;
  private _providerContract: DcpEntryGroup;

  @Input() set providerContract(contractGroups: DcpEntryGroup) {
    this._providerContract = contractGroups;
    this.derivativePrice$ = this.contractPriceService.getDerivativeTotal(contractGroups?.entryGroups);
  }

  get providerContract() {
    return this._providerContract;
  }

  constructor(
    private contractPriceService: ContractPriceService,
  ) {
  }

  openDerivativesModal() {
    this.isModalOpened = true;
  }
}
